import React, { memo } from 'react';
import { Shot, ViewMode, DragHandlers } from '../types';
import GridView from './GridView';
import ListView from './ListView';

export interface SceneCardProps {
  shot: Shot;
  sceneIndex: number;
  viewMode: ViewMode;
  hasUpdatePermission: boolean;
  hasDeletePermission: boolean;
  isDragging?: boolean;
  onUpdateShot: (updates: Partial<Shot>) => void;
  onDeleteShot: () => void;
  onDuplicateShot: () => void;
  onSaveShot: () => Promise<void>;
  addFileToQueue: (payload: any, orgId: string) => Promise<string>;
  organisationId: string;
  dragHandlers?: DragHandlers;
  commentCount?: number;
  onComment?: () => void;
  onSwitchToListView: () => void;
}

function SceneCard({
  shot,
  sceneIndex,
  viewMode,
  hasUpdatePermission,
  hasDeletePermission,
  isDragging = false,
  onUpdateShot,
  onDeleteShot,
  onDuplicateShot,
  onSaveShot,
  addFileToQueue,
  organisationId,
  dragHandlers,
  commentCount,
  onComment,
  onSwitchToListView
}: SceneCardProps) {
  const cardStyles: React.CSSProperties = { transition: 'all 0.2s ease' };

  const commonProps = {
    shot,
    sceneIndex,
    hasUpdatePermission,
    hasDeletePermission,
    isDragging,
    cardStyles,
    onUpdateShot,
    onDeleteShot,
    onDuplicateShot,
    onSaveShot,
    addFileToQueue,
    organisationId,
    dragHandlers,
    commentCount,
    onComment,
    onSwitchToListView
  };

  return viewMode === 'grid' ? <GridView {...commonProps} /> : <ListView {...commonProps} />;
}

export default memo(SceneCard);
